'use client';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import './index.scss';
import EcoImgVideo from 'eco-design/base/eco-img-video';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { title, list, desc, theme, footerList, pc, h5 } = data;
    const prefixCls = 'index-our-story-nl';
    console.log('=====pc=====', pc);

    return (
        <GloLayout className={`editor-${prefixCls} editor-${prefixCls}-${id}`} id={id} data={data} floorName={`${prefixCls}`}>
            <div
                className={`${prefixCls}-wrapper`}
                style={{
                    color: theme,
                }}
            >
                {/* 底图容器：图片独立div，所有内容浮动在上方 */}
                <div className={`${prefixCls}-backdrop OurStory-img`}>
                    <EcoImgVideo isVideo={false} pc={pc} h5={h5 || pc} alt={title} />
                    {/* <img
                        className={`${prefixCls}-bg-img`}
                        src="https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=2072&auto=format&fit=crop"
                        alt="Duurzame energie achtergrond met zonnepanelen en windmolens"
                        loading="eager"
                    /> */}
                </div>

                {/* 浮动在图片上的内容层 */}
                <div className={`${prefixCls}-content`}>
                    {/* 头部标题区 */}
                    <div className={`${prefixCls}-hero`}>
                        <h1 className={`${prefixCls}-title`}>{title}</h1>
                        <div className={`${prefixCls}-subtitle`}>
                            <p>{desc}</p>
                        </div>
                    </div>

                    {/* 统计数据：单行整体居中；换行则左对齐 */}
                    <div className={`${prefixCls}-stats-row`}>
                        <div className={`${prefixCls}-stats-grid`}>
                            {list.map((stat: { subtitle?: string; desc?: string }, idx: number) => (
                                <div key={idx} className={`${prefixCls}-stat-card`}>
                                    <div className={`${prefixCls}-stat-number`}>{stat.subtitle}</div>
                                    <div className={`${prefixCls}-stat-label`}>{stat.desc}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* 核心优势网格 - 使用 map 渲染 */}
                    <div className={`${prefixCls}-features-grid`}>
                        {footerList.map((feature: { title?: string; description?: string }, idx: number) => (
                            <div key={idx} className={`${prefixCls}-feature-card`}>
                                <h3 className={`${prefixCls}-feature-title`}>{feature.title}</h3>
                                <p className={`${prefixCls}-feature-desc`}>{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </GloLayout>
    );
}
